/**
* AppInstaller.js
* 
* Created 2021-03
*
* @author reinier@ranj.nl
**/

import ContextEvent from './ContextEvent';
import MediatorManager from './MediatorManager';
import AssetLibrary from '../assetloading/AssetLibrary';
import Config from '../config/Config.js';
import RevisableLanguagePack from "../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import SoundManager from "../../../../lib/html5-software-library/src/ranj/audio/SoundManager";

import Startup from '../startup/Startup.js';
import StartupCommand from '../startup/StartupCommand.js';
import TaskFactory from '../../../../lib/html5-software-library/src/ranj/util/executor/TaskFactory.js';

//import GoogleAnalyticsInstaller from '../../analytics/GoogleAnalyticsInstaller.js';
import ScreenNavigationInstaller from '../navigation/ScreenNavigationInstaller.js';
import AbstractInstaller from './AbstractInstaller.js';
import MediatorMapping from './MediatorMapping';
import DestroyCommand from './DestroyCommand.js';
import AssetLoadService from '../assetloading/AssetLoadService.js';
import LayoutInstaller from '../../layout/LayoutInstaller.js';
import MinigameInstaller from '../../../../../src/ranj/equalture/MinigameInstaller';

/////////////
import DebugToolsInstaller from '../../debug/core/DebugToolsInstaller.js';
import { AppSignalInstaller } from '../../app-signal/AppSignalInstaller';
//////////

export default class AppInstaller extends AbstractInstaller {

    /**
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        // ---------------------
        //      Generic
        // ---------------------

        injector.mapClass("languagePack", RevisableLanguagePack, true);
        injector.mapClass("assetLibrary", AssetLibrary, true);
        injector.mapClass("assetLoadService", AssetLoadService, true);
        // Make sure an instance of the mediator manager exists, so screen navigation events are monitored.
        const mediatorManager = injector.createInstance(MediatorManager);
        injector.mapValue("mediatorManager", mediatorManager);
        injector.mapClass("config", Config, true);

        commands.add(ContextEvent.STARTUP, StartupCommand);
        commands.add(ContextEvent.DESTROY, DestroyCommand);

        // Set up lifecycle objects to which installer can add 
        // See corresponding convenience methods in AbstractInstaller
        injector.mapClass("taskFactory", TaskFactory, true);
        injector.mapClass("startup", Startup, true);

        // Sound
        injector.mapClass("soundManager", SoundManager, true);

        // Screen navigation  
        this._install(ScreenNavigationInstaller);

/////////////////////
        // Debug modules        
        this._install(DebugToolsInstaller);
//////////////////

        // -------------------------------
        //      Project specific
        // -------------------------------

        this._addAssetsToConfigurationManifest(
            { id: "assets", src: "assets/assets.json" },
            { id: "config", src: "assets/config.json" }
        );

        // install project specific modules
        this._install(MinigameInstaller);
        this._install(AppSignalInstaller); // Error tracking (should be after AppModel is populated, so after MinigameInstaller)
        this._install(LayoutInstaller);
        //this._install(GoogleAnalyticsInstaller);
    }

}

/**
 * Id of asset group list used for preloading (before splash screen is shown). 
 * This typically contains the visual assets and language file for the splash screen. 
 */
AppInstaller.PRELOAD_ASSET_GROUPS = "preloadAssetGroups";

/**
 * Id of asset group list that will be loaded during startup (while splash screen is shown). 
 * This typically contains the main visual assets, sounds, languagepacks etc
 */
AppInstaller.STARTUP_ASSET_GROUPS = "startupAssetGroups";